<h2 mat-dialog-title>
    {{ awaitingCode ? 'Validation du compte' : 'Créer un nouveau compte' }}
  </h2>
  
  <mat-dialog-content [formGroup]="awaitingCode ? codeForm : emailForm">
    <!-- Étape 1 : saisie de l'email -->
    <ng-container *ngIf="!awaitingCode">
      <mat-form-field appearance="fill" class="full-width">
        <mat-label>Adresse email</mat-label>
        <input matInput formControlName="email" placeholder="exemple@domaine.com">
        <mat-error *ngIf="emailForm.get('email')?.hasError('required')">
          L'email est requis
        </mat-error>
        <mat-error *ngIf="emailForm.get('email')?.hasError('email')">
          Format invalide
        </mat-error>
      </mat-form-field>
    </ng-container>
  
    <!-- Étape 2 : saisie du code -->
    <ng-container *ngIf="awaitingCode">
      <p>Un code de sécurité a été envoyé à <strong>{{ emailForm.value.email }}</strong>.</p>
      <mat-form-field appearance="fill" class="full-width">
        <mat-label>Code de sécurité</mat-label>
        <input matInput formControlName="code" placeholder="1234">
        <mat-error *ngIf="codeForm.get('code')?.hasError('required')">
          Le code est requis
        </mat-error>
      </mat-form-field>
    </ng-container>
  </mat-dialog-content>
  
  <mat-dialog-actions align="end">
    <button mat-button (click)="onNoClick()">Annuler</button>
    <button
      mat-flat-button color="primary"
      (click)="awaitingCode ? submitCode() : submitEmail()"
      [disabled]="(awaitingCode ? codeForm.invalid : emailForm.invalid)">
      {{ awaitingCode ? 'Valider le code' : 'Envoyer' }}
    </button>
  </mat-dialog-actions>
  